import { render, staticRenderFns } from "./AiAssistantDrawer.vue?vue&type=template&id=cf7866fc&scoped=true"
import script from "./AiAssistantDrawer.vue?vue&type=script&lang=ts"
export * from "./AiAssistantDrawer.vue?vue&type=script&lang=ts"
import style0 from "./AiAssistantDrawer.vue?vue&type=style&index=0&id=cf7866fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7866fc",
  null
  
)

export default component.exports